import { call, put, select, all } from 'redux-saga/effects';
import * as types from '../../constants/ActionTypes';
import Api from '../../functions/Api';
import { deleteListedData } from './publishingListedSaga';

export function* deleteMultipleImages(action) {
  try {
    const { imageIds, idProduct, endpoint } = action;

    const coverIds = yield select((state) =>
      imageIds.reduce((acc, idElement) => {
        const img = state.publishing.receivedPublishData.images.find(
          (x) => x.id === idElement
        );
        acc[idElement] = Boolean(img?.cover);
        return acc;
      }, {})
    );

    yield all(
      imageIds.map((idElement) =>
        call(deleteListedData, {
          idProduct,
          idElement,
          endpoint,
          type: types.DELETE_LISTED_DATA,
        })
      )
    );

    if (Object.values(coverIds).some(Boolean)) {
      yield put({
        type: types.REQUEST_PRODUCT,
        id: idProduct,
      });

      const questId = yield select((state) => state.quests.currentQuestId);

      yield put({
        type: types.FETCH_QUEST,
        id: questId,
        isForSync: true,
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error deleting multiple images:', error);
    yield put({
      type: types.DELETE_LISTED_DATA_FAILURE,
      errors: [error],
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

/**
 * Sends new order of product images to server
 * @param {Object} action
 * @param {Number} action.productId - id of the product to sync images order
 */
export function* syncProductImagesOrder({ productId }) {
  const imageIds = yield select((state) =>
    state.publishing.receivedPublishData.images.map((img) => img.id)
  );

  try {
    yield call(Api.patch, `v2/products/${productId}/images/`, {
      data: { order: imageIds },
    });
  } catch (error) {
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

/**
 * Reorders images locally and syncs their order with server
 * @param {Object} action
 * @param {Number} action.productId - id of the product which images order should be synced
 * @param {...Object} - will be sent to `REORDER_PRODUCT_IMAGES` action
 */
export function* reorderProductImages({ productId, ...action }) {
  yield put({ ...action, type: types.REORDER_PRODUCT_IMAGES });

  if (!action.isUpload) {
    yield call(syncProductImagesOrder, { productId });
  }
}
